import { Alert } from "@aman/design-system";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../auth/AuthContext";

export function ProtectedRoute() {
  const auth = useAuth();
  const location = useLocation();
  const { t } = useTranslation();
  if (auth.loading) return <main className="full-page-loader"><span className="aman-spinner" /><span>{t("auth.sessionCheck")}</span></main>;
  if (auth.user === null) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (auth.resellerOnly && !location.pathname.startsWith("/reseller")) return <Navigate to="/reseller" replace />;
  if (auth.customerOnly && !location.pathname.startsWith("/customer")) return <Navigate to="/customer" replace />;
  if (auth.error !== undefined) return <main className="centered-message"><Alert tone="error" title={t("errors.title")}><code>{auth.error.code}</code></Alert></main>;
  return <Outlet />;
}

export function AdminRoute() {
  const auth = useAuth();
  if (auth.resellerOnly) return <Navigate to="/reseller" replace />;
  if (auth.customerOnly) return <Navigate to="/customer" replace />;
  return <Outlet />;
}
